import {
  DeadlineStickerValue,
  GenericStickerState,
  Hub,
  StickerSettingsInBoard,
  StickerType,
  TimerStickerValue
} from 'yougile-model'
import {deadlineTimerView} from '../sticker-menu/sticker-menu-deadline/utils'

interface GetIsRunningTimer {
  stickerType: StickerType
  stickerValue?: GenericStickerState
  stickerDefaultValue?: GenericStickerState
  location: string
  task?: Hub
  settings?: StickerSettingsInBoard
}

export const getIsRunningTimer = ({
  stickerType,
  stickerValue,
  stickerDefaultValue,
  location,
  task,
  settings
}: GetIsRunningTimer): boolean => {
  const isDeadLineRunning =
    stickerType === 'deadline' &&
    task &&
    deadlineTimerView(
      task,
      stickerDefaultValue as DeadlineStickerValue,
      settings
    )

  const isStopwatchTimerRunning =
    ['stopwatch', 'timer'].includes(stickerType) &&
    (stickerValue as TimerStickerValue)?.current?.running

  return location === 'task' && !!(isStopwatchTimerRunning || isDeadLineRunning)
}
